import React from "react";

import { useIntl } from "react-intl";

import MarkerShape from "@mapmycustomers/shared/enum/MarkerShape";

import FrequencyInfo from "@app/component/frequency/FrequencyPanel/component/FrequencyInfo";

import styles from "../../ColorKeyLegendCard/components/FrequencyStatusColorKey.module.scss";

import ShapeBadge from "./ShapeBadge";
import ShapeKey from "./ShapeKey";

interface Props {}

const FrequencyStatusShapeKey: React.FC<Props> = () => {
  const intl = useIntl();

  return (
    <div className={styles.container}>
      <ShapeKey>
        <div>
          <ShapeBadge
            label={intl.formatMessage({
              id: "map.layer.shapeKey.legend.frequencyStatus.option.upToDate",
              defaultMessage: "Up to Date",
              description: "Up to Date option in Cadence Status Shape legend",
            })}
            shape={MarkerShape.CIRCLE}
          />
        </div>
        <div>
          <ShapeBadge
            label={intl.formatMessage({
              id: "map.layer.shapeKey.legend.frequencyStatus.option.upcoming",
              defaultMessage: "Upcoming",
              description: "Upcoming option in Cadence Status Shape legend",
            })}
            shape={MarkerShape.TRIANGLE}
          />
        </div>
        <div>
          <ShapeBadge
            label={intl.formatMessage({
              id: "map.layer.shapeKey.legend.frequencyStatus.option.pastDue",
              defaultMessage: "Past Due",
              description: "No Cadence option in Cadence Status Shape legend",
            })}
            shape={MarkerShape.FLAG}
          />
        </div>
        <div>
          <ShapeBadge
            label={intl.formatMessage({
              id: "map.layer.shapeKey.legend.frequencyStatus.option.noFrequency",
              defaultMessage: "No frequency / no contact yet",
              description: "No frequency option in Cadence Status Shape legend",
            })}
            shape={MarkerShape.SQUARE}
          />
        </div>
      </ShapeKey>
      <div className={styles.info}>
        <FrequencyInfo />
      </div>
    </div>
  );
};

export default FrequencyStatusShapeKey;
